import React from "react";
import { Container, Row } from "react-bootstrap";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import SelectedItemsFromCatelogueCategoryInside from "./SelectedItemsFromCatelogueCategoryInside";

function SelectedItemsFromCatelogueCategory(props) {
  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <Container fluid>
              <div className="super-admin-inside-right-side-panel">
                <SelectedItemsFromCatelogueCategoryInside dash={true} />
              </div>
            </Container>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default SelectedItemsFromCatelogueCategory;
